// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body,
#root {
  height: 100%;
  overflow: hidden;
}

body {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  color: #f8fafc;
  overflow-x: hidden;
  min-height: 100vh;
}

.app {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--background);
  color: var(--foreground);
  overflow: hidden;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  border-bottom: 1px solid var(--border);
  background-color: var(--background);
  flex-shrink: 0;
  height: 70px;
}

.header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--accent), transparent);
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 16px;
}

.logo-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-icon {
  width: 36px;
  height: 36px;
  transition: all 0.3s ease;
}

.logo-pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 36px;
  border: 2px solid var(--accent);
  border-radius: 50%;
  opacity: 0;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.7;
  }
  70% {
    transform: translate(-50%, -50%) scale(1.4);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.4);
    opacity: 0;
  }
}

.brand-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.header h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--foreground);
  margin: 0;
}

.brand-subtitle {
  font-size: 0.75rem;
  color: var(--muted-foreground);
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.header-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 20px;
  background-color: var(--muted);
  border: 1px solid var(--border);
  transition: all 0.3s ease;
}

.status-indicator.online {
  background-color: rgba(34, 197, 94, 0.1);
  border-color: rgba(34, 197, 94, 0.3);
}

.status-indicator.offline {
  background-color: rgba(239, 68, 68, 0.1);
  border-color: rgba(239, 68, 68, 0.3);
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--muted-foreground);
  transition: all 0.3s ease;
}

.status-indicator.online .status-dot {
  background-color: #22c55e;
  box-shadow: 0 0 8px rgba(34, 197, 94, 0.5);
  animation: statusPulse 2s infinite;
}

.status-indicator.offline .status-dot {
  background-color: #ef4444;
}

@keyframes statusPulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.2);
  }
}

.status-text {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--foreground);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 44px;
  height: 44px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--card);
  color: var(--foreground);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.action-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  transition: left 0.5s ease;
}

.action-button:hover::before {
  left: 100%;
}

.action-button:hover {
  background: var(--muted);
  color: var(--foreground);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-color: var(--border);
}

.action-button.github-link:hover {
  background: #24292e;
  border-color: #24292e;
  color: white;
  box-shadow: 0 8px 25px rgba(36, 41, 46, 0.3);
}

.action-text {
  font-size: 0.8rem;
  font-weight: 600;
  display: none;
}

@media (min-width: 768px) {
  .action-text {
    display: block;
  }

  .action-button {
    min-width: auto;
    padding: 0 16px;
  }
}

.main {
  flex: 1 1;
  padding: 1rem 2rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.section-tabs {
  display: flex;
  gap: 8px;
  width: 100%;
  max-width: 800px;
  justify-content: center;
}

.section-tabs button {
  padding: 10px 20px;
  background-color: #2d3748; /* Slightly lighter than darkCard */
  color: #cbd5e1; /* darkTextSecondary */
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.section-tabs button.active {
  background-color: #0066cc; /* primary */
  color: #ffffff; /* white */
}

.section-tabs button:hover:not(.active) {
  background-color: #4a5568; /* Medium gray */
  color: #f8fafc; /* darkText */
}

.app-sections {
  display: flex;
  gap: 1rem;
  height: 100%;
  overflow: hidden;
}

.left-panel,
.right-panel {
  background-color: #1e293b; /* darkCard */
  border: 1px solid #334155; /* darkBorder */
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.left-panel {
  padding: 0;
  display: flex;
  flex-direction: column;
}

.task-section,
.chat-section,
.computer-section {
  background: var(--card);
  backdrop-filter: blur(20px);
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  padding: 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  height: 100%;
  width: 100%;
}

.task-section::before,
.chat-section::before,
.computer-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(96, 165, 250, 0.5),
    transparent
  );
}

.task-section h2,
.chat-section h2,
.computer-section h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--foreground);
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.task-section h2::before {
  content: "💼";
  font-size: 1.1rem;
}

.chat-section h2::before {
  content: "💬";
  font-size: 1.1rem;
}

.computer-section h2::before {
  content: "🖥️";
  font-size: 1.1rem;
}

.task-details {
  flex: 1 1;
  overflow-y: auto;
  background-color: var(--muted);
  border-radius: 8px;
  padding: 16px;
  margin-top: 12px;
}

.screenshot-container {
  flex: 1 1;
  overflow: auto;
  margin-top: 12px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: var(--muted);
  border-radius: 8px;
  padding: 16px;
}

.screenshot-container img {
  max-width: 100%;
  border: 1px solid var(--border);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.left-panel h2,
.right-panel h2 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--foreground);
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.messages {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
  padding-right: 0.5rem;
  min-height: 0;
}

.messages::-webkit-scrollbar {
  width: 6px;
}

.messages::-webkit-scrollbar-track {
  background: var(--muted);
  border-radius: 3px;
}

.messages::-webkit-scrollbar-thumb {
  background: var(--muted-foreground);
  border-radius: 3px;
}

.placeholder {
  text-align: center;
  color: var(--muted-foreground);
  margin: 2rem 0;
  font-size: 0.875rem;
}

.message {
  max-width: 85%;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  line-height: 1.5;
  position: relative;
  animation: messageSlide 0.3s ease-out;
}

@keyframes messageSlide {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-message {
  background-color: var(--accent);
  color: var(--accent-foreground);
  align-self: flex-end;
}

.agent-message {
  background-color: var(--muted);
  color: var(--foreground);
  align-self: flex-start;
  border: 1px solid var(--border);
}

.error-message {
  background-color: var(--destructive);
  color: var(--destructive-foreground);
  align-self: flex-start;
}

.message-header {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.agent-name {
  font-size: 0.75rem;
  color: var(--muted-foreground);
  font-weight: 500;
}

.reasoning-toggle {
  background-color: var(--secondary);
  border: 1px solid var(--border);
  border-radius: 6px;
  color: var(--secondary-foreground);
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  width: fit-content;
}

.reasoning-toggle:hover {
  background-color: var(--muted);
}

.reasoning-content {
  margin-top: 0.75rem;
  padding: 0.75rem;
  background-color: var(--secondary);
  border: 1px solid var(--border);
  border-radius: 6px;
  font-size: 0.8rem;
}

.loading-animation {
  text-align: center;
  color: var(--muted-foreground);
  padding: 0.75rem;
  font-size: 0.875rem;
  border-top: 1px solid var(--border);
  flex-shrink: 0;
}

.input-form {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background-color: var(--card);
  border-radius: 24px;
  border: 1px solid var(--border);
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.input-form:focus-within {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.input-form input {
  flex: 1 1;
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  background-color: transparent;
  border: none;
  color: var(--foreground);
  border-radius: 20px;
  outline: none;
  font-family: inherit;
}

.input-form input::placeholder {
  color: var(--muted-foreground);
}

.input-form .action-buttons {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.input-form .icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: var(--foreground);
  color: var(--background);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.input-form .icon-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  background-color: var(--muted-foreground);
}

.input-form .icon-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.input-form .icon-button.stop-button {
  background-color: var(--destructive);
  color: var(--destructive-foreground);
}

.input-form .icon-button.stop-button:hover {
  background-color: #dc2626;
}

.view-selector {
  display: flex;
  gap: 0.25rem;
  margin-bottom: 1rem;
  padding: 0.25rem;
  background-color: var(--muted);
  border-radius: 8px;
  flex-shrink: 0;
}

.view-selector button {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  background-color: transparent;
  color: var(--muted-foreground);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  flex: 1 1;
}

.view-selector button.active {
  background-color: var(--background);
  color: var(--foreground);
}

.view-selector button:hover:not(.active) {
  color: var(--foreground);
}

.content {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

.content::-webkit-scrollbar {
  width: 6px;
}

.content::-webkit-scrollbar-track {
  background: var(--muted);
  border-radius: 3px;
}

.content::-webkit-scrollbar-thumb {
  background: var(--muted-foreground);
  border-radius: 3px;
}

.blocks {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.block {
  background-color: var(--card);
  padding: 1rem;
  border: 1px solid var(--border);
  border-radius: 8px;
}

.block-tool,
.block-feedback,
.block-success,
.block-failure {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.block-success {
  color: #22c55e;
}

.block-failure {
  color: #ef4444;
}

.block-failure::before {
  content: "❌";
}

.block-feedback {
  color: #cbd5e1;
}

.block-feedback::before {
  content: "💬";
}

.block pre {
  background: var(--muted);
  padding: 16px;
  border-radius: 8px;
  font-size: 0.85rem;
  white-space: pre-wrap;
  word-break: break-all;
  color: var(--muted-foreground);
  margin: 12px 0;
  font-family: "JetBrains Mono", "Fira Code", "Menlo", monospace;
  border-left: 3px solid var(--muted-foreground);
  overflow-x: auto;
}

.screenshot {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: var(--muted);
  border-radius: 12px;
  border: 1px solid var(--border);
}

.screenshot img {
  max-width: 100%;
  border: 2px solid var(--border);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.screenshot img:hover {
  transform: scale(1.02);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.error {
  color: var(--destructive-foreground);
  font-size: 0.9rem;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: rgba(239, 68, 68, 0.1);
  border-radius: 8px;
  border-left: 3px solid var(--destructive);
  display: flex;
  align-items: center;
  gap: 8px;
}

.error::before {
  content: "⚠️";
}

@media (max-width: 1200px) {
  .main {
    padding: 24px;
  }

  .app-sections {
    gap: 24px;
  }
}

@media (max-width: 768px) {
  .main {
    padding: 16px;
  }

  .chat-section,
  .computer-section {
    height: 50vh;
    min-height: 400px;
  }

  .header {
    padding: 0.75rem 1.25rem;
  }

  .header h1 {
    font-size: 1.75rem;
  }

  .message {
    max-width: 90%;
    padding: 12px 16px;
  }

  .view-selector button {
    padding: 10px 16px;
    font-size: 0.85rem;
  }

  .input-form {
    padding: 0.75rem 1rem;
    border-radius: 20px;
  }

  .input-form input {
    padding: 0.75rem;
    font-size: 0.9rem;
  }

  .input-form .icon-button {
    width: 36px;
    height: 36px;
  }

  .input-form .icon-button.stop-button {
    width: 36px;
    height: 36px;
  }
}

@media (max-width: 480px) {
  .main {
    padding: 12px;
  }

  .chat-section,
  .computer-section {
    padding: 16px;
    min-height: 350px;
  }

  .header h1 {
    font-size: 1.5rem;
  }

  .message {
    padding: 10px 14px;
    font-size: 0.9rem;
  }

  .block {
    padding: 16px;
  }

  .block pre {
    font-size: 0.8rem;
    padding: 12px;
  }

  .input-form {
    padding: 0.5rem 0.75rem;
  }

  .input-form input {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
  }

  .input-form .icon-button {
    width: 34px;
    height: 34px;
  }

  .input-form .icon-button.stop-button {
    width: 34px;
    height: 34px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;cACY;EACZ,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE;IACE,yCAAyC;IACzC,YAAY;EACd;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,mCAAmC;EAC9D,cAAc,EAAE,sBAAsB;EACtC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,YAAY;EACvC,cAAc,EAAE,UAAU;AAC5B;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB,EAAE,aAAa;EACxC,yBAAyB,EAAE,eAAe;EAC1C,kBAAkB;EAClB;sCACoC;EACpC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;GAKC;AACH;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;EACd,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,SAAO;AACT;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,8BAA8B;EAC9B,cAAc;EACd,8DAA8D;EAC9D,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  overflow: hidden;\n}\n\nbody {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    sans-serif;\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  color: #f8fafc;\n  overflow-x: hidden;\n  min-height: 100vh;\n}\n\n.app {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--background);\n  color: var(--foreground);\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  border-bottom: 1px solid var(--border);\n  background-color: var(--background);\n  flex-shrink: 0;\n  height: 70px;\n}\n\n.header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, var(--accent), transparent);\n}\n\n.header-brand {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.logo-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logo-icon {\n  width: 36px;\n  height: 36px;\n  transition: all 0.3s ease;\n}\n\n.logo-pulse {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 36px;\n  height: 36px;\n  border: 2px solid var(--accent);\n  border-radius: 50%;\n  opacity: 0;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: translate(-50%, -50%) scale(1);\n    opacity: 0.7;\n  }\n  70% {\n    transform: translate(-50%, -50%) scale(1.4);\n    opacity: 0;\n  }\n  100% {\n    transform: translate(-50%, -50%) scale(1.4);\n    opacity: 0;\n  }\n}\n\n.brand-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.header h1 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--foreground);\n  margin: 0;\n}\n\n.brand-subtitle {\n  font-size: 0.75rem;\n  color: var(--muted-foreground);\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.header-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.status-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  background-color: var(--muted);\n  border: 1px solid var(--border);\n  transition: all 0.3s ease;\n}\n\n.status-indicator.online {\n  background-color: rgba(34, 197, 94, 0.1);\n  border-color: rgba(34, 197, 94, 0.3);\n}\n\n.status-indicator.offline {\n  background-color: rgba(239, 68, 68, 0.1);\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: var(--muted-foreground);\n  transition: all 0.3s ease;\n}\n\n.status-indicator.online .status-dot {\n  background-color: #22c55e;\n  box-shadow: 0 0 8px rgba(34, 197, 94, 0.5);\n  animation: statusPulse 2s infinite;\n}\n\n.status-indicator.offline .status-dot {\n  background-color: #ef4444;\n}\n\n@keyframes statusPulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(1.2);\n  }\n}\n\n.status-text {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--foreground);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.action-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-width: 44px;\n  height: 44px;\n  padding: 0 12px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--card);\n  color: var(--foreground);\n  text-decoration: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.action-button::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.1),\n    transparent\n  );\n  transition: left 0.5s ease;\n}\n\n.action-button:hover::before {\n  left: 100%;\n}\n\n.action-button:hover {\n  background: var(--muted);\n  color: var(--foreground);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  border-color: var(--border);\n}\n\n.action-button.github-link:hover {\n  background: #24292e;\n  border-color: #24292e;\n  color: white;\n  box-shadow: 0 8px 25px rgba(36, 41, 46, 0.3);\n}\n\n.action-text {\n  font-size: 0.8rem;\n  font-weight: 600;\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .action-text {\n    display: block;\n  }\n\n  .action-button {\n    min-width: auto;\n    padding: 0 16px;\n  }\n}\n\n.main {\n  flex: 1;\n  padding: 1rem 2rem;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.section-tabs {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n  max-width: 800px;\n  justify-content: center;\n}\n\n.section-tabs button {\n  padding: 10px 20px;\n  background-color: #2d3748; /* Slightly lighter than darkCard */\n  color: #cbd5e1; /* darkTextSecondary */\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.section-tabs button.active {\n  background-color: #0066cc; /* primary */\n  color: #ffffff; /* white */\n}\n\n.section-tabs button:hover:not(.active) {\n  background-color: #4a5568; /* Medium gray */\n  color: #f8fafc; /* darkText */\n}\n\n.app-sections {\n  display: flex;\n  gap: 1rem;\n  height: 100%;\n  overflow: hidden;\n}\n\n.left-panel,\n.right-panel {\n  background-color: #1e293b; /* darkCard */\n  border: 1px solid #334155; /* darkBorder */\n  border-radius: 8px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.left-panel {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.task-section,\n.chat-section,\n.computer-section {\n  background: var(--card);\n  backdrop-filter: blur(20px);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n.task-section::before,\n.chat-section::before,\n.computer-section::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(96, 165, 250, 0.5),\n    transparent\n  );\n}\n\n.task-section h2,\n.chat-section h2,\n.computer-section h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--foreground);\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.task-section h2::before {\n  content: \"💼\";\n  font-size: 1.1rem;\n}\n\n.chat-section h2::before {\n  content: \"💬\";\n  font-size: 1.1rem;\n}\n\n.computer-section h2::before {\n  content: \"🖥️\";\n  font-size: 1.1rem;\n}\n\n.task-details {\n  flex: 1;\n  overflow-y: auto;\n  background-color: var(--muted);\n  border-radius: 8px;\n  padding: 16px;\n  margin-top: 12px;\n}\n\n.screenshot-container {\n  flex: 1;\n  overflow: auto;\n  margin-top: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  background-color: var(--muted);\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.screenshot-container img {\n  max-width: 100%;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.left-panel h2,\n.right-panel h2 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--foreground);\n  margin-bottom: 8px;\n  letter-spacing: 1px;\n}\n\n.messages {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  padding-right: 0.5rem;\n  min-height: 0;\n}\n\n.messages::-webkit-scrollbar {\n  width: 6px;\n}\n\n.messages::-webkit-scrollbar-track {\n  background: var(--muted);\n  border-radius: 3px;\n}\n\n.messages::-webkit-scrollbar-thumb {\n  background: var(--muted-foreground);\n  border-radius: 3px;\n}\n\n.placeholder {\n  text-align: center;\n  color: var(--muted-foreground);\n  margin: 2rem 0;\n  font-size: 0.875rem;\n}\n\n.message {\n  max-width: 85%;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  position: relative;\n  animation: messageSlide 0.3s ease-out;\n}\n\n@keyframes messageSlide {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.user-message {\n  background-color: var(--accent);\n  color: var(--accent-foreground);\n  align-self: flex-end;\n}\n\n.agent-message {\n  background-color: var(--muted);\n  color: var(--foreground);\n  align-self: flex-start;\n  border: 1px solid var(--border);\n}\n\n.error-message {\n  background-color: var(--destructive);\n  color: var(--destructive-foreground);\n  align-self: flex-start;\n}\n\n.message-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.agent-name {\n  font-size: 0.75rem;\n  color: var(--muted-foreground);\n  font-weight: 500;\n}\n\n.reasoning-toggle {\n  background-color: var(--secondary);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  color: var(--secondary-foreground);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: fit-content;\n}\n\n.reasoning-toggle:hover {\n  background-color: var(--muted);\n}\n\n.reasoning-content {\n  margin-top: 0.75rem;\n  padding: 0.75rem;\n  background-color: var(--secondary);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  font-size: 0.8rem;\n}\n\n.loading-animation {\n  text-align: center;\n  color: var(--muted-foreground);\n  padding: 0.75rem;\n  font-size: 0.875rem;\n  border-top: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.input-form {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  background-color: var(--card);\n  border-radius: 24px;\n  border: 1px solid var(--border);\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n}\n\n.input-form:focus-within {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.input-form input {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  font-size: 0.95rem;\n  background-color: transparent;\n  border: none;\n  color: var(--foreground);\n  border-radius: 20px;\n  outline: none;\n  font-family: inherit;\n}\n\n.input-form input::placeholder {\n  color: var(--muted-foreground);\n}\n\n.input-form .action-buttons {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.input-form .icon-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background-color: var(--foreground);\n  color: var(--background);\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.input-form .icon-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  background-color: var(--muted-foreground);\n}\n\n.input-form .icon-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.input-form .icon-button.stop-button {\n  background-color: var(--destructive);\n  color: var(--destructive-foreground);\n}\n\n.input-form .icon-button.stop-button:hover {\n  background-color: #dc2626;\n}\n\n.view-selector {\n  display: flex;\n  gap: 0.25rem;\n  margin-bottom: 1rem;\n  padding: 0.25rem;\n  background-color: var(--muted);\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.view-selector button {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  background-color: transparent;\n  color: var(--muted-foreground);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  flex: 1;\n}\n\n.view-selector button.active {\n  background-color: var(--background);\n  color: var(--foreground);\n}\n\n.view-selector button:hover:not(.active) {\n  color: var(--foreground);\n}\n\n.content {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.content::-webkit-scrollbar-track {\n  background: var(--muted);\n  border-radius: 3px;\n}\n\n.content::-webkit-scrollbar-thumb {\n  background: var(--muted-foreground);\n  border-radius: 3px;\n}\n\n.blocks {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.block {\n  background-color: var(--card);\n  padding: 1rem;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n}\n\n.block-tool,\n.block-feedback,\n.block-success,\n.block-failure {\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}\n\n.block-success {\n  color: #22c55e;\n}\n\n.block-failure {\n  color: #ef4444;\n}\n\n.block-failure::before {\n  content: \"❌\";\n}\n\n.block-feedback {\n  color: #cbd5e1;\n}\n\n.block-feedback::before {\n  content: \"💬\";\n}\n\n.block pre {\n  background: var(--muted);\n  padding: 16px;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  white-space: pre-wrap;\n  word-break: break-all;\n  color: var(--muted-foreground);\n  margin: 12px 0;\n  font-family: \"JetBrains Mono\", \"Fira Code\", \"Menlo\", monospace;\n  border-left: 3px solid var(--muted-foreground);\n  overflow-x: auto;\n}\n\n.screenshot {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  background: var(--muted);\n  border-radius: 12px;\n  border: 1px solid var(--border);\n}\n\n.screenshot img {\n  max-width: 100%;\n  border: 2px solid var(--border);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n}\n\n.screenshot img:hover {\n  transform: scale(1.02);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);\n}\n\n.error {\n  color: var(--destructive-foreground);\n  font-size: 0.9rem;\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  background: rgba(239, 68, 68, 0.1);\n  border-radius: 8px;\n  border-left: 3px solid var(--destructive);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.error::before {\n  content: \"⚠️\";\n}\n\n@media (max-width: 1200px) {\n  .main {\n    padding: 24px;\n  }\n\n  .app-sections {\n    gap: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .main {\n    padding: 16px;\n  }\n\n  .chat-section,\n  .computer-section {\n    height: 50vh;\n    min-height: 400px;\n  }\n\n  .header {\n    padding: 0.75rem 1.25rem;\n  }\n\n  .header h1 {\n    font-size: 1.75rem;\n  }\n\n  .message {\n    max-width: 90%;\n    padding: 12px 16px;\n  }\n\n  .view-selector button {\n    padding: 10px 16px;\n    font-size: 0.85rem;\n  }\n\n  .input-form {\n    padding: 0.75rem 1rem;\n    border-radius: 20px;\n  }\n\n  .input-form input {\n    padding: 0.75rem;\n    font-size: 0.9rem;\n  }\n\n  .input-form .icon-button {\n    width: 36px;\n    height: 36px;\n  }\n\n  .input-form .icon-button.stop-button {\n    width: 36px;\n    height: 36px;\n  }\n}\n\n@media (max-width: 480px) {\n  .main {\n    padding: 12px;\n  }\n\n  .chat-section,\n  .computer-section {\n    padding: 16px;\n    min-height: 350px;\n  }\n\n  .header h1 {\n    font-size: 1.5rem;\n  }\n\n  .message {\n    padding: 10px 14px;\n    font-size: 0.9rem;\n  }\n\n  .block {\n    padding: 16px;\n  }\n\n  .block pre {\n    font-size: 0.8rem;\n    padding: 12px;\n  }\n\n  .input-form {\n    padding: 0.5rem 0.75rem;\n  }\n\n  .input-form input {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.85rem;\n  }\n\n  .input-form .icon-button {\n    width: 34px;\n    height: 34px;\n  }\n\n  .input-form .icon-button.stop-button {\n    width: 34px;\n    height: 34px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
